import { render, staticRenderFns } from "./AccordionKeysForm.vue?vue&type=template&id=2340a705&scoped=true&"
import script from "./AccordionKeysForm.vue?vue&type=script&lang=js&"
export * from "./AccordionKeysForm.vue?vue&type=script&lang=js&"
import style0 from "./AccordionKeysForm.vue?vue&type=style&index=0&id=2340a705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340a705",
  null
  
)

export default component.exports